import { useTranslation } from 'react-i18next'
import Button from "../Buttons/Button"
import ButtonQuote from "../Buttons/ButtonQuote"
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Service = ({service}) => {
    const { t } = useTranslation()
    
    const form = useRef()
    const formBis = useRef()
    const sendEmail = (e) => {
        e.preventDefault()
        const sendButton = document.getElementById('sendButton')
        sendButton.innerHTML = 'Sending...'
        emailjs.sendForm('service_6u4ljhg', 'template_7vec4jb', form.current, 'g5TX7imVVLB2Hsy8y')
            .then(() => {
                sendButton.innerHTML = 'Send'
                toast.success('¡Success! you will recieve a response in no time', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '🚀'
                })
                e.target.reset()
                const checkbox = document.getElementsByClassName("checkboxOptions")
                for (let i = 0; i < checkbox.length; i++) {
                    checkbox[i].checked = false
                }
            }, (error) => {
                console.log(error.text)
                sendButton.innerHTML = 'Send'
                toast.error('Error, please try again ', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '❌'
                })
            })
    }

    const sendEmailBis = (e) => {
        e.preventDefault()
        const sendButton = document.getElementById('sendButtonBis')
        sendButton.innerHTML = 'Sending...'
        emailjs.sendForm('service_6u4ljhg', 'template_7vec4jb', formBis.current, 'g5TX7imVVLB2Hsy8y')
            .then(() => {
                sendButton.innerHTML = 'Send'
                toast.success('¡Success! you will recieve a response in no time', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '🚀'
                })
                e.target.reset()
                const checkbox = document.getElementsByClassName("checkboxOptions")
                for (let i = 0; i < checkbox.length; i++) {
                    checkbox[i].checked = false
                }
            }, (error) => {
                console.log(error.text)
                sendButton.innerHTML = 'Send'
                toast.error('Error, please try again ', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: false,
                    icon: '❌'
                })
            })
    }


    let servicios = ""
    const actualizarServicios = (e) => {
        if (e.target.checked) {
            servicios += e.target.value.toUpperCase() + " | "
            document.getElementById("user_services").value = servicios
        } else {
            servicios = servicios.replace(e.target.value.toUpperCase() + " | ", "")
            document.getElementById("user_services").value = servicios
        }
    }

    return (
        <div>
            <ButtonQuote/>
            <div>
                <div className="w-full">
                    <div className="flex items-center justify-evenly h-auto">
                        <div>
                            <h1 className="h1-macro px-10 py-10 bottom-0 flex-col no-selection space-y-4"><p>{ t(service.t1) }</p></h1>
                            <div className="flex-col space-y-6 px-10">
                                <h2 className="font-semibold text-xl md:text-2xl lg:text-2xl xl:text-3xl">{ t('services_tagline') }</h2>
                                {
                                    service.header.map((element, index) => {
                                        return (
                                            <p key={index} className="text-xl">{ t(element) }</p>
                                        )
                                    })
                                }
                                <p className="text-xl font-bold">{ t('services_dates1') } { t(service.time) } { t('services_dates2') }</p>

                                <Button call={`${ t('services_call') } ${ t(service.info) }`} link={'/contact'}/>
                            </div>
                        </div>
                        <img src={service.brain} alt="brain" className="hidden md:block lg:block xl:block w-1/3"/>
                    </div>
                    
                </div>

                <div>

                    <div className="bg-bk text-white my-20">
                        <div className="px-4 col-start-2 col-end-3 flex flex-col justify-center items-center py-10">
                            <h3 className="font-bold text-2xl xs:text-4xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-5xl">{ t('services_explanation_1') } { t(service.info) } { t('services_explanation_2') }</h3>
                            <div className="flex flex-col items-center justify-center gap-y-10 sm:flex-row sm:gap-x-10 sm:px-10 md:flex-row md:gap-x-10 md:px-10 lg:flex-row lg:gap-x-10 lg:px-10 xl:flex-row xl:gap-x-10 xl:px-10 mt-20">
                                {
                                    service.benefits.map((element, index) => {
                                        return (
                                            <div key={index}>
                                                <img src={element.img} alt='benefit icon' className="grow w-20 h-20 mx-auto"/>
                                                <p className="mt-4">{ t(element.text) }</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    {
                        service.toCheck ?
                        <div>
                            <div className="flex flex-col justify-center items-center">
                                <h3 className="font-bold text-3xl xs:text-4xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-5xl px-4 text-center">{ t('services_check_title') } { t(service.info) }?</h3>
                            </div>
                            <div>
                                <p className="px-6 text-md text-center my-10">{ t('services_call_quote') } 🚀 </p>
                                <form id="webElementsForm" className="mb-20" ref={form} onSubmit={sendEmail}>
                                    <input className="hidden" type="text" id="user_services" name="user_services" />
                                    <div className="flex flex-wrap mx-auto justify-center w-8/12 gap-x-4 gap-y-10">
                                        {service.toCheck.map((element, index) => {
                                            return (
                                                <section key={index} className="flex no-selection">
                                                    <input className="checkboxOptions border-2 border-gray-300 p-2 hidden" type="checkbox" id={element.id} name={element.id} value={element.id} onChange={actualizarServicios} />
                                                    <label htmlFor={element.id} className="toCheck text-center p-2 text-sm cursor-pointer">
                                                        <img src={element.img} alt={element.id} className="w-20 no-selection h-20 mx-auto"/>
                                                        <p className="mt-2">{ t(element.text) }</p>
                                                    </label>
                                                </section>
                                            )
                                        })}
                                    </div>
                                    <div className="flex mt-14 justify-center items-center">
                                        <input className="w-64 md:w-1/4 lg:w-1/4 bg-default h-10 px-3 border-l-2 border-t-2 border-b-2 rounded-l-md border-gray-300 text-center focus:border-indigo-500" placeholder="binarybrains.dev@gmail.com" type="text" id="user_email" name="user_email" required />
                                        <button className="bg-accent text-white px-4 py-2 h-10 rounded-r-md" id="sendButton" type="submit">{ t('button_send') }</button>
                                    </div>
                                </form>
                            </div>

                            <div className="flex flex-col justify-center items-center bg-bk py-12 lg:py-12 h-max text-white">
                                <h3 className="font-bold text-2xl xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-4xl">{ t('services_call_notsure') }</h3>
                                <p className="px-6 text-md text-center mt-4">{ t('services_call_notsure_help') }</p>
                                <form className="flex mt-6 justify-center items-center" ref={formBis} onSubmit={sendEmailBis}>
                                    <input className="w-64 bg-default h-10 px-3 border-l-2 border-t-2 border-b-2 rounded-l-md border-gray-300 text-center focus:border-indigo-500" placeholder="binarybrains.dev@gmail.com" type="text" id="user_email" name="user_email" required />
                                    <button className="bg-accent text-white px-4 py-2 h-10 rounded-r-md" id="sendButtonBis" type="submit">{ t('button_send') }</button>
                                </form>
                            </div>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>
    )    
}

export default Service